import { selectorFamily } from "recoil";

import { carModelService } from "./carModel.service";

export const carsQuery = selectorFamily({
    key: "cars",
    get: (type: string) => () => carModelService.getCars(type),
});
